import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { SavedQueryCondition } from '../../types/QueryBuilder';

export interface QueryDetails {
    QUERY_ID: string;
    USER_ID: string;
    QUERY_TYPE: string;
    DESCRIPTION: string;
    SOURCE: string;
    UPDATE_DATE: string;
    QUERY_NAME: string;
    GROUP_QUERY_ID?: string | null;
    conditions?: SavedQueryCondition[] | null;
}

export const useQueryDetails = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchQueryDetails = useCallback(async (queryId: string): Promise<QueryDetails | null> => {
        if (!isReady || !queryId) return null;

        setLoading(true);
        setError(null);

        try {
            return await authFetch(`/getQueryById?queryId=${queryId}`, { method: 'GET' }) as QueryDetails;
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Erreur de récupération des détails');
            return null;
        } finally {
            setLoading(false);
        }
    }, [authFetch, isReady]);

    return { fetchQueryDetails, loading, error };
};

